// src/components/brand-result-listing/brand-result-listing.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment SponsoredContentBeaconsFragment on SponsoredContentBeacons {\n    renderBeacons\n    viewabilityBeacon\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSImageFragment on Image {\n    url\n    description\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    orientation\n    size\n    url {\n      ... on HttpURI {\n        __typename\n        value\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      ...UILinkActionFragment\n    }\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      urls\n    }\n    resource {\n      ... on HttpURI {\n        value\n      }\n    }\n    target\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment VideoFragment on SponsoredContentVideo {\n    description\n    videoAccessibility\n    volumeButtonAccessibility\n    url {\n      value\n    }\n    thumbnail {\n      value\n    }\n    link {\n      ...UILinkActionFragment\n    }\n    viewAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    muteAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    unmuteAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    firstQuartileAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    midpointAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    thirdQuartileAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    videoCompleteAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    videoBufferingAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  query BrandResultListingQuery(\n    $context: ContextInput!\n    $sponsoredContentContext: SponsoredContentContextInput!\n    $shoppingCriteriaInput: ProductShoppingCriteriaInput\n  ) {\n    sponsoredContent {\n      brandResultListing(context: $context, sponsoredContentContext: $sponsoredContentContext, shoppingCriteriaInput: $shoppingCriteriaInput) {\n        heading\n        paragraph\n        adTransparencyTrigger {\n          adTransparencyId\n          adTransparencyButton {\n            ...AdTransparencyButtonFragment\n          }\n          adTransparencyOverlaySkeleton {\n            ...TransparencyOverlaySkeletonFragment\n          }\n        }\n        beacons {\n          ...SponsoredContentBeaconsFragment\n        }\n        impressionAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n        link {\n          ...UILinkActionFragment\n        }\n        badge {\n          ...EGDSStandardBadgeFragment\n        }\n        feature {\n          ...EGDSImageFragment\n        }\n        logo {\n          standard {\n            ...EGDSMarkFragment\n          }\n        }\n        video {\n          ...VideoFragment\n        }\n      }\n    }\n  }\n\n  fragment AdTransparencyButtonFragment on AdTransparencyButton {\n    primary\n    accessibility\n    disabled\n    icon {\n      description\n      id\n      title\n    }\n    analyticsPayload\n  }\n  fragment TransparencyOverlaySkeletonFragment on TransparencyOverlaySkeleton {\n    title\n    error {\n      icon {\n        id\n        size\n      }\n      description\n      button {\n        primary\n      }\n      allowedRetryAttempts\n      exceededAttemptsMessage\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
import React13 from "react";
import LazyLoad2 from "react-lazy-load";
import { gql as gql8 } from "@apollo/client";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
// ../internal/src/components/analytics/client-side-analytics.ts
import { gql } from "@apollo/client";
import { ITrackType, useClickTracker } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/beacons/use-beacons.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/components/utils/logger-utils.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
  FAIL_TO_SEND_BEACON_USING_BEACON_API: new SystemEvent(SystemEventLevel.WARN, "FAIL_TO_SEND_BEACON_USING_BEACON_API" /* FAIL_TO_SEND_BEACON_USING_BEACON_API */)
};
// ../internal/src/components/beacons/use-beacons.tsx
var SponsoredContentBeaconsFragment = gql2(_templateObject1());
var fireBeacon = function (beacon, events) {
  try {
    if (!navigator.sendBeacon(encodeURI(beacon))) {
      events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({});
    }
  } catch (error) {
    events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({
      error: error
    });
  }
};
var useBeacons = function (beacons) {
  var loggerEvents = useLoggerEvents(EVENTS);
  React.useEffect(function () {
    if (beacons) {
      var _beacons_renderBeacons;
      (_beacons_renderBeacons = beacons.renderBeacons) === null || _beacons_renderBeacons === void 0 ? void 0 : _beacons_renderBeacons.forEach(function (impression) {
        fireBeacon(impression, loggerEvents);
      });
    }
  }, []);
};
// ../internal/src/components/egds-image/egds-image.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkImage } from "uitk-react-images";
var fragment = gql3(_templateObject2());
var EGDSImage = function (param) {
  var data = param.data;
  return /* @__PURE__ */React2.createElement(UitkImage, {
    alt: data.description,
    src: data.url
  });
};
EGDSImage.fragment = fragment;
EGDSImage.displayName = "EGDSImage";
// ../internal/src/components/egds-mark/egds-mark.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
// ../internal/src/components/egds-mark/utils/index.ts
var markSizeMapper = {
  "4": 4,
  "5": 5,
  "6": 6,
  "7": 7,
  "8": 8,
  "9": 9,
  "10": 10,
  "11": 11,
  "12": 12,
  "13": 13,
  "14": 14,
  "15": 15,
  "16": 16,
  "17": 17,
  "18": 18,
  "24": 24,
  "30": 30,
  "37": 37,
  "38": 38,
  "40": 40,
  "48": 48,
  "72": 72
};
var _obj;
var orientationMap = (_obj = {}, _define_property(_obj, "LANDSCAPE" /* LANDSCAPE */, "landscape"), _define_property(_obj, "PORTRAIT" /* PORTRAIT */, "portrait"), _obj);
// ../internal/src/components/egds-mark/egds-mark.tsx
var __EGDSMarkFragment = gql4(_templateObject3());
var EGDSMark = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var description = data.description,
    id = data.id,
    orientation = data.orientation,
    url = data.url;
  var markSize;
  if (size) {
    markSize = markSizeMapper[size];
  } else if (data.size) {
    markSize = markSizeMapper[data.size];
  } else {
    markSize = void 0;
  }
  var markOrientation = orientation && orientationMap[orientation] || "landscape";
  return /* @__PURE__ */React3.createElement(UitkMark, {
    className: className,
    description: description,
    id: id,
    name: id,
    orientation: markOrientation,
    size: markSize,
    url: url === null || url === void 0 ? void 0 : url.value
  });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React4 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
var fragment2 = gql5(_templateObject4());
var EGDSStandardBadge = function (param) {
  var data = param.data;
  if (!data.text) {
    return null;
  }
  var _data_accessibility;
  return /* @__PURE__ */React4.createElement(UitkBadgeStandard, {
    size: "small",
    text: data.text,
    a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
  });
};
EGDSStandardBadge.fragment = fragment2;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/ui-action-link/ui-action-link.tsx
import React5 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var EGDSInlineLinkFragment = gql6(_templateObject5());
var fragment3 = gql6(_templateObject6());
var _obj1;
var UILinkTargetMap = (_obj1 = {}, _define_property(_obj1, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj1, "INTERNAL" /* INTERNAL */, "_self"), _obj1);
var UILinkAction = function (param) {
  var className = param.className,
    data = param.data,
    children = param.children;
  var accessibility = data.accessibility,
    resource = data.resource,
    target = data.target,
    analytics = data.analytics;
  var clickTracker = useClickTracker2();
  var onClick = React5.useCallback(function () {
    var _analytics_urls;
    analytics === null || analytics === void 0 ? void 0 : (_analytics_urls = analytics.urls) === null || _analytics_urls === void 0 ? void 0 : _analytics_urls.forEach(function (url) {
      var _navigator;
      (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon(url);
    });
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) && (analytics === null || analytics === void 0 ? void 0 : analytics.linkName)) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  }, [clickTracker]);
  if (resource.__typename !== "HttpURI") {
    return null;
  }
  return /* @__PURE__ */React5.createElement("a", {
    className: className,
    target: UILinkTargetMap[target],
    href: resource.value,
    rel: "noopener noreferrer",
    onClickCapture: onClick
  }, accessibility && /* @__PURE__ */React5.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility), children);
};
UILinkAction.fragment = fragment3;
UILinkAction.displayName = "UILinkAction";
// ../internal/src/components/video-player/video-player.tsx
import React6, { useEffect, useRef, useState } from "react";
import { gql as gql7 } from "@apollo/client";
import { ITrackType as ITrackType2, useClickstreamAnalytics, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2, useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
import { UitkIcon } from "uitk-react-icons";
import { UitkFigure } from "uitk-react-images";
import { UitkLayoutPosition } from "uitk-react-layout-position";
var fragment4 = gql7(_templateObject7(), clientSideAnalyticsFragment, UILinkAction.fragment);
var VIDEO_LOAD_ERROR_EVENT = new SystemEvent2(SystemEventLevel2.ERROR, "VIDEO_LOAD_ERROR");
var VideoPlayer = function (props) {
  var _props_data = props.data,
    videoAccessibility = _props_data.videoAccessibility,
    volumeButtonAccessibility = _props_data.volumeButtonAccessibility,
    url = _props_data.url,
    thumbnail = _props_data.thumbnail,
    link = _props_data.link,
    viewAnalytics = _props_data.viewAnalytics,
    muteAnalytics = _props_data.muteAnalytics,
    unmuteAnalytics = _props_data.unmuteAnalytics,
    firstQuartileAnalytics = _props_data.firstQuartileAnalytics,
    midpointAnalytics = _props_data.midpointAnalytics,
    thirdQuartileAnalytics = _props_data.thirdQuartileAnalytics,
    videoCompleteAnalytics = _props_data.videoCompleteAnalytics,
    videoBufferingAnalytics = _props_data.videoBufferingAnalytics,
    ratio = props.ratio;
  var videoElement = useRef(null);
  var _useState = _sliced_to_array(useState({
      firstQuartile: false,
      midpoint: false,
      thirdQuartile: false,
      viewed: false
    }), 2),
    calledVideoAction = _useState[0],
    updateCalledVideoAction = _useState[1];
  var analyticsTracker = useClickTracker3();
  var track = useClickstreamAnalytics().track;
  var events = useLoggerEvents2({
    VIDEO_LOAD_ERROR_EVENT: VIDEO_LOAD_ERROR_EVENT
  });
  var trackClickAnalytics2 = function (analytics) {
    if (analytics.referrerId && analytics.linkName) {
      analyticsTracker(analytics.referrerId, analytics.linkName);
    }
  };
  var trackImpressionAnalytics2 = function (analytics) {
    if (analytics.referrerId && analytics.linkName) {
      track(ITrackType2.EVENT, {
        data: {
          schemaName: "referrer",
          messageContent: {
            referrerId: analytics.referrerId,
            linkName: analytics.linkName,
            eventType: "impression"
          }
        }
      });
    }
  };
  var _useState1 = _sliced_to_array(useState(true), 2),
    isMuted = _useState1[0],
    setIsMuted = _useState1[1];
  var _useState2 = _sliced_to_array(useState(false), 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var observer = new IntersectionObserver(function (param) {
    var _param = _sliced_to_array(param, 1),
      entry = _param[0];
    if (entry) {
      setIsVisible(entry.isIntersecting);
    }
  }, {
    threshold: 0.5
  });
  var muteClickHandler = function () {
    if (_instanceof(videoElement.current, HTMLVideoElement)) {
      if (videoElement.current.muted) {
        trackClickAnalytics2(unmuteAnalytics);
      } else {
        trackClickAnalytics2(muteAnalytics);
      }
      videoElement.current.muted = !videoElement.current.muted;
    }
    setIsMuted(!isMuted);
  };
  var handleTimeProgress = function () {
    var video = videoElement.current;
    if (video != null && video.duration !== 0) {
      var viewed = video.currentTime >= 2;
      var firstQuartileComplete = video.currentTime / video.duration >= 0.25;
      var midpointComplete = video.currentTime / video.duration >= 0.5;
      var thirdQuartileComplete = video.currentTime / video.duration >= 0.75;
      if (viewed && !calledVideoAction.viewed) {
        trackImpressionAnalytics2(viewAnalytics);
        updateCalledVideoAction(_object_spread_props(_object_spread({}, calledVideoAction), {
          viewed: true
        }));
      }
      if (firstQuartileComplete && !calledVideoAction.firstQuartile) {
        trackImpressionAnalytics2(firstQuartileAnalytics);
        updateCalledVideoAction(_object_spread_props(_object_spread({}, calledVideoAction), {
          firstQuartile: true
        }));
      }
      if (midpointComplete && !calledVideoAction.midpoint) {
        trackImpressionAnalytics2(midpointAnalytics);
        updateCalledVideoAction(_object_spread_props(_object_spread({}, calledVideoAction), {
          midpoint: true
        }));
      }
      if (thirdQuartileComplete && !calledVideoAction.thirdQuartile) {
        trackImpressionAnalytics2(thirdQuartileAnalytics);
        updateCalledVideoAction(_object_spread_props(_object_spread({}, calledVideoAction), {
          thirdQuartile: true
        }));
      }
    }
  };
  var _useState3 = _sliced_to_array(useState(1), 2),
    loopCount = _useState3[0],
    setLoopCount = _useState3[1];
  var handleVideoComplete = function () {
    if (videoElement.current) {
      if (loopCount <= 10) {
        if (videoCompleteAnalytics) {
          var videoCompleteWithLoopAnalytics = {
            referrerId: "".concat(videoCompleteAnalytics.referrerId, ".").concat(loopCount),
            linkName: videoCompleteAnalytics.linkName
          };
          trackImpressionAnalytics2(videoCompleteWithLoopAnalytics);
        }
      }
      setLoopCount(loopCount + 1);
      videoElement.current.play();
    }
  };
  var handleVideoBuffering = function () {
    if (videoElement.current && videoElement.current.currentTime !== 0) {
      trackImpressionAnalytics2(videoBufferingAnalytics);
    }
  };
  var handleLoadError = function () {
    events.VIDEO_LOAD_ERROR_EVENT.log({
      videoSrc: url.value
    });
  };
  var _useState4 = _sliced_to_array(useState(true), 2),
    isTabVisible = _useState4[0],
    setIsTabVisible = _useState4[1];
  var handleVisibilityChange = function () {
    setIsTabVisible(document.visibilityState === "visible");
  };
  useEffect(function () {
    if (videoElement.current) {
      observer.observe(videoElement.current);
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return function () {
      observer.disconnect();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  useEffect(function () {
    if (_instanceof(videoElement.current, HTMLVideoElement)) {
      if (isVisible && isTabVisible) {
        videoElement.current.play();
      } else {
        videoElement.current.pause();
      }
    }
  }, [isVisible, isTabVisible]);
  var videoComponent = /* @__PURE__ */React6.createElement("video", {
    "aria-label": videoAccessibility !== null && videoAccessibility !== void 0 ? videoAccessibility : void 0,
    controlsList: "nodownload noplaybackrate",
    disablePictureInPicture: true,
    id: "video-player",
    muted: true,
    onEnded: handleVideoComplete,
    onError: handleLoadError,
    onTimeUpdate: handleTimeProgress,
    onWaiting: handleVideoBuffering,
    playsInline: true,
    poster: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.value,
    preload: "auto",
    ref: videoElement,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }, /* @__PURE__ */React6.createElement("source", {
    src: url.value
  }));
  return /* @__PURE__ */React6.createElement(UitkFigure, {
    ratio: ratio,
    imageFit: "cover"
  }, /* @__PURE__ */React6.createElement(React6.Fragment, null, link ? /* @__PURE__ */React6.createElement(UILinkAction, {
    data: link
  }, videoComponent) : {
    videoComponent: videoComponent
  }, /* @__PURE__ */React6.createElement(UitkLayoutPosition, {
    type: "absolute",
    position: {
      zindex: "layer3",
      right: "three",
      bottom: "three"
    }
  }, /* @__PURE__ */React6.createElement("button", {
    id: "muteButton",
    style: {
      background: "none",
      border: "none"
    },
    type: "button",
    onClick: muteClickHandler,
    "aria-label": volumeButtonAccessibility !== null && volumeButtonAccessibility !== void 0 ? volumeButtonAccessibility : void 0
  }, isMuted ? /* @__PURE__ */React6.createElement(UitkIcon, {
    name: "volume_off",
    theme: "inverse"
  }) : /* @__PURE__ */React6.createElement(UitkIcon, {
    name: "volume_up",
    theme: "inverse"
  })))));
};
VideoPlayer.fragment = fragment4;
VideoPlayer.displayName = "Video";
// src/components/brand-result-listing/brand-result-listing.tsx
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/brand-result-listing/brand-result-listing-lazy-fetch.tsx
import React11 from "react";
import { useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/ad-block-detect/ad-block-detect.tsx
import React7 from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { SystemEvent as SystemEvent3, SystemEventLevel as SystemEventLevel3, useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
var AD_BLOCK_DETECTED_EVENT = new SystemEvent3(SystemEventLevel3.INFO, "AD_BLOCK_DETECTED");
var CollapsedComponent = function () {
  var events = useLoggerEvents3({
    AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
  });
  events.AD_BLOCK_DETECTED_EVENT.log({
    message: "collapsing"
  });
  return null;
};
var UncollapsedWrappedComponent = function (props) {
  var children = props.children;
  var events = useLoggerEvents3({
    AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
  });
  events.AD_BLOCK_DETECTED_EVENT.log({
    message: "not collapsing"
  });
  return /* @__PURE__ */React7.createElement(React7.Fragment, null, children);
};
function withAdBlockDetect(WrapperComponent) {
  var WithAdBlockDetectHOC = function (componentProps) {
    var collapseWhenAdBlockDetected = componentProps.collapseWhenAdBlockDetected,
      adBlockCollapseExperiment = componentProps.adBlockCollapseExperiment;
    var UncollapsedComponent = /* @__PURE__ */React7.createElement(UncollapsedWrappedComponent, null, /* @__PURE__ */React7.createElement(WrapperComponent, _object_spread({}, componentProps)));
    var renderVariant = function () {
      if (adBlockCollapseExperiment === "PG_Acceptable_Ads_Enablement") {
        return /* @__PURE__ */React7.createElement(Experiment, {
          name: "PG_Acceptable_Ads_Enablement"
        }, /* @__PURE__ */React7.createElement(ExperimentControl, null, /* @__PURE__ */React7.createElement(CollapsedComponent, null)), /* @__PURE__ */React7.createElement(ExperimentVariant, {
          bucket: 1
        }, UncollapsedComponent));
      }
      if (adBlockCollapseExperiment === "Acceptable_Ads_Component_Enablement") {
        return UncollapsedComponent;
      }
      return /* @__PURE__ */React7.createElement(CollapsedComponent, null);
    };
    if (typeof window !== "undefined") {
      var _window_meso;
      window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
      if (!window.meso.adblock || window.meso.adblock.enabled) {
        if (adBlockCollapseExperiment) {
          return /* @__PURE__ */React7.createElement(Experiment, {
            name: "Acceptable_Ads_Component_Enablement"
          }, /* @__PURE__ */React7.createElement(ExperimentControl, null, /* @__PURE__ */React7.createElement(CollapsedComponent, null)), /* @__PURE__ */React7.createElement(ExperimentVariant, {
            bucket: 1
          }, renderVariant()));
        }
        if (collapseWhenAdBlockDetected === false) {
          return UncollapsedComponent;
        }
        return /* @__PURE__ */React7.createElement(CollapsedComponent, null);
      }
    }
    return /* @__PURE__ */React7.createElement(WrapperComponent, _object_spread({}, componentProps));
  };
  WithAdBlockDetectHOC.displayName = "WithAdBlockDetectHOC";
  return WithAdBlockDetectHOC;
}
// ../internal/src/components/meso-viewability/meso-viewability.ts
import React8, { useCallback } from "react";
var useMesoViewability = function (param) {
  var viewabilityBeacon = param.viewabilityBeacon;
  var componentRef = React8.useRef(null);
  var deRegisterViewability = useCallback(function (currentRef) {
    if (currentRef && window.meso) {
      var _window_meso_viewability;
      window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
      window.meso.viewability.push({
        type: "deregister",
        element: currentRef
      });
    }
  }, []);
  var registerViewability = useCallback(function (currentRef) {
    if (currentRef) {
      var _window_meso;
      window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
      var _window_meso_viewability;
      window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
      window.meso.viewability.push({
        type: "register",
        config: "image",
        // the config settings to use: image, video, or large-image
        element: currentRef,
        // reference to the DOM element
        beacon: viewabilityBeacon
      });
    }
  }, [viewabilityBeacon]);
  React8.useEffect(function () {
    var currentRef = componentRef.current;
    registerViewability(currentRef);
    return function () {
      deRegisterViewability(currentRef);
    };
  }, [registerViewability, deRegisterViewability]);
  return {
    componentRef: componentRef
  };
};
// ../internal/src/components/utils/constants.ts
var DEFAULT_SPONSORED_BATCH_KEY = "sponsored-content";
var DEFAULT_SPONSORED_FETCH_POLICY = "no-cache";
// src/components/brand-result-listing/brand-result-listing-lazy-fetch.tsx
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard2, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
// src/components/brand-result-listing/utils.tsx
var GAM_AD_URL_QUERY_PARAM = "adurl=";
var fillNumOfTravelersInLink = function (link, rooms) {
  if (link && link.resource.__typename === "HttpURI" && link.resource.value.toString().includes("search") && rooms) {
    var resource = link === null || link === void 0 ? void 0 : link.resource.value;
    var redirectUrl = resource.substring(resource.indexOf(GAM_AD_URL_QUERY_PARAM) + GAM_AD_URL_QUERY_PARAM.length);
    var searchParams = new URLSearchParams(redirectUrl || "");
    searchParams.append("NumRoom", rooms.length.toString());
    for (var roomNum = 0; roomNum < rooms.length; roomNum += 1) {
      var _rooms_roomNum, _rooms_roomNum1;
      var children = ((_rooms_roomNum = rooms[roomNum]) === null || _rooms_roomNum === void 0 ? void 0 : _rooms_roomNum.children) || [];
      searchParams.append("NumAdult".concat(roomNum + 1), "".concat(((_rooms_roomNum1 = rooms[roomNum]) === null || _rooms_roomNum1 === void 0 ? void 0 : _rooms_roomNum1.adults) || ""));
      searchParams.append("NumChild".concat(roomNum + 1), children.length.toString());
      for (var childNum = 0; childNum < children.length; childNum += 1) {
        var _children_childNum;
        searchParams.append("Rm".concat(roomNum + 1, "child").concat(childNum + 1, "age"), "".concat(((_children_childNum = children[childNum]) === null || _children_childNum === void 0 ? void 0 : _children_childNum.age) || ""));
      }
    }
    return _object_spread_props(_object_spread({}, link), {
      resource: _object_spread_props(_object_spread({}, link.resource), {
        value: link.resource.value.replace(redirectUrl, searchParams.toString())
      })
    });
  }
  return link;
};
// src/components/brand-result-listing/__private/lazy-brand-result-listing-content.tsx
import React9 from "react";
import { Transparency } from "@shared-ui/retail-sponsored-content-transparency";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2 } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkParagraph } from "uitk-react-text";
var TransparencyTriggerOrBadge = function (param) {
  var badge = param.badge,
    adTransparencyTrigger = param.adTransparencyTrigger;
  var badgePositionProps = (adTransparencyTrigger === null || adTransparencyTrigger === void 0 ? void 0 : adTransparencyTrigger.adTransparencyId) ? {
    bottom: "three",
    left: "three",
    zindex: "layer3"
  } : {
    bottom: "three",
    left: "three",
    zindex: "layer1"
  };
  return /* @__PURE__ */React9.createElement(UitkLayoutPosition2, {
    type: "absolute",
    position: badgePositionProps,
    cloneElement: true
  }, adTransparencyTrigger ? /* @__PURE__ */React9.createElement(Transparency, {
    data: adTransparencyTrigger
  }) : badge && /* @__PURE__ */React9.createElement("div", null, /* @__PURE__ */React9.createElement(EGDSStandardBadge, {
    data: badge
  })));
};
var LazyBrandResultListingContent = function (param) {
  var data = param.data,
    impressionOnly = param.impressionOnly;
  var badge = data.badge,
    heading = data.heading,
    paragraph = data.paragraph,
    feature = data.feature,
    logo = data.logo,
    beacons = data.beacons,
    adTransparencyTrigger = data.adTransparencyTrigger;
  useBeacons(beacons);
  if (impressionOnly) {
    return null;
  }
  return /* @__PURE__ */React9.createElement(UitkLayoutGrid, {
    alignItems: "center",
    columns: 3
  }, /* @__PURE__ */React9.createElement(TransparencyTriggerOrBadge, {
    badge: badge,
    adTransparencyTrigger: adTransparencyTrigger
  }), /* @__PURE__ */React9.createElement(UitkLayoutGridItem, {
    colSpan: 1
  }, /* @__PURE__ */React9.createElement(UitkFigure2, {
    imageFit: "cover"
  }, /* @__PURE__ */React9.createElement(EGDSImage, {
    data: feature
  }))), /* @__PURE__ */React9.createElement(UitkLayoutGridItem, {
    colSpan: 2,
    alignSelf: "start"
  }, /* @__PURE__ */React9.createElement(UitkCardContentSection, null, /* @__PURE__ */React9.createElement(UitkLayoutFlex, {
    direction: "column",
    justifyContent: "start"
  }, (logo === null || logo === void 0 ? void 0 : logo.standard) && /* @__PURE__ */React9.createElement(UitkLayoutFlexItem, {
    grow: 0,
    maxWidth: 100
  }, /* @__PURE__ */React9.createElement(UitkSpacing, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React9.createElement("div", null, /* @__PURE__ */React9.createElement(EGDSMark, {
    data: logo.standard
  })))), /* @__PURE__ */React9.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React9.createElement(UitkHeading, {
    tag: "h3",
    size: 5
  }, heading)), /* @__PURE__ */React9.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React9.createElement(UitkSpacing, {
    margin: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React9.createElement(UitkParagraph, {
    size: 2
  }, paragraph)))))));
};
var LazyBrandResultListingContentMobile = function (param) {
  var data = param.data,
    impressionOnly = param.impressionOnly;
  var badge = data.badge,
    heading = data.heading,
    paragraph = data.paragraph,
    feature = data.feature,
    logo = data.logo,
    beacons = data.beacons,
    adTransparencyTrigger = data.adTransparencyTrigger;
  useBeacons(beacons);
  if (impressionOnly) {
    return null;
  }
  return /* @__PURE__ */React9.createElement(UitkLayoutGrid, {
    columns: 3
  }, /* @__PURE__ */React9.createElement(TransparencyTriggerOrBadge, {
    badge: badge,
    adTransparencyTrigger: adTransparencyTrigger
  }), /* @__PURE__ */React9.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React9.createElement(UitkFigure2, {
    imageFit: "cover",
    ratio: UitkFigureAspectRatioType2.R21_9
  }, /* @__PURE__ */React9.createElement(EGDSImage, {
    data: feature
  }))), /* @__PURE__ */React9.createElement(UitkLayoutGridItem, {
    colSpan: 2
  }, /* @__PURE__ */React9.createElement(UitkCardContentSection, null, /* @__PURE__ */React9.createElement(UitkLayoutFlex, {
    direction: "column",
    justifyContent: "start"
  }, (logo === null || logo === void 0 ? void 0 : logo.standard) && /* @__PURE__ */React9.createElement(UitkLayoutFlexItem, {
    grow: 0,
    maxWidth: 100
  }, /* @__PURE__ */React9.createElement("div", null, /* @__PURE__ */React9.createElement(EGDSMark, {
    data: logo.standard
  }))), /* @__PURE__ */React9.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React9.createElement(UitkSpacing, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React9.createElement(UitkHeading, {
    tag: "h2",
    size: 6
  }, heading))), /* @__PURE__ */React9.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React9.createElement(UitkSpacing, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React9.createElement(UitkParagraph, {
    size: 2
  }, paragraph)))))));
};
// src/components/brand-result-listing/__private/video-ad-content.tsx
import React10 from "react";
import { Transparency as Transparency2 } from "@shared-ui/retail-sponsored-content-transparency";
import { UitkCard, UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkFigure as UitkFigure3, UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing2, UitkSpacingHr } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkParagraph as UitkParagraph2 } from "uitk-react-text";
var TransparencyTriggerOrBadge2 = function (param) {
  var badge = param.badge,
    adTransparencyTrigger = param.adTransparencyTrigger;
  var badgePositionProps = {
    bottom: "three",
    left: "three",
    zindex: "layer3"
  };
  return /* @__PURE__ */React10.createElement(UitkLayoutPosition3, {
    type: "absolute",
    position: badgePositionProps
  }, adTransparencyTrigger ? /* @__PURE__ */React10.createElement(Transparency2, {
    data: adTransparencyTrigger
  }) : badge && /* @__PURE__ */React10.createElement(EGDSStandardBadge, {
    data: badge
  }));
};
var VideoAdContent = function (param) {
  var data = param.data,
    impressionOnly = param.impressionOnly;
  var link = data.link,
    badge = data.badge,
    heading = data.heading,
    paragraph = data.paragraph,
    logo = data.logo,
    beacons = data.beacons,
    adTransparencyTrigger = data.adTransparencyTrigger,
    video = data.video;
  useBeacons(beacons);
  if (impressionOnly || !video) {
    return null;
  }
  return /* @__PURE__ */React10.createElement(UitkCard, {
    border: true
  }, link && /* @__PURE__ */React10.createElement(UitkCardLink, null, /* @__PURE__ */React10.createElement(UILinkAction, {
    data: link
  })), /* @__PURE__ */React10.createElement(UitkLayoutGrid2, {
    alignItems: "center",
    columns: 3
  }, /* @__PURE__ */React10.createElement(TransparencyTriggerOrBadge2, {
    badge: badge,
    adTransparencyTrigger: adTransparencyTrigger
  }), /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, {
    colSpan: 2
  }, /* @__PURE__ */React10.createElement(UitkLayoutPosition3, {
    type: "relative",
    position: {
      zindex: "layer2"
    }
  }, /* @__PURE__ */React10.createElement(UitkFigure3, {
    ratio: UitkFigureAspectRatioType3.R16_9,
    imageFit: "cover"
  }, /* @__PURE__ */React10.createElement(VideoPlayer, {
    data: video
  })))), /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, {
    colSpan: 1,
    alignSelf: "center"
  }, /* @__PURE__ */React10.createElement(UitkCardContentSection2, null, /* @__PURE__ */React10.createElement(UitkLayoutFlex2, {
    direction: "column",
    justifyContent: "start"
  }, (logo === null || logo === void 0 ? void 0 : logo.standard) && /* @__PURE__ */React10.createElement(UitkLayoutFlexItem2, {
    grow: 0,
    maxWidth: 100
  }, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(EGDSMark, {
    data: logo.standard
  }))), /* @__PURE__ */React10.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React10.createElement(UitkSpacing2, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React10.createElement(UitkHeading2, {
    tag: "h3",
    size: 5
  }, heading))), /* @__PURE__ */React10.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React10.createElement(UitkSpacing2, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React10.createElement(UitkParagraph2, {
    size: 1
  }, paragraph))))))));
};
var VideoAdContentMobile = function (param) {
  var data = param.data,
    impressionOnly = param.impressionOnly;
  var link = data.link,
    badge = data.badge,
    heading = data.heading,
    paragraph = data.paragraph,
    feature = data.feature,
    logo = data.logo,
    beacons = data.beacons,
    adTransparencyTrigger = data.adTransparencyTrigger,
    video = data.video;
  useBeacons(beacons);
  if (impressionOnly || !video) {
    return null;
  }
  var clickableComponent = function (children) {
    return link ? /* @__PURE__ */React10.createElement(UitkLink, null, /* @__PURE__ */React10.createElement(UILinkAction, {
      data: link
    }, children)) : children;
  };
  return /* @__PURE__ */React10.createElement(React10.Fragment, null, /* @__PURE__ */React10.createElement(UitkSpacingHr, {
    blockMargin: "six"
  }), /* @__PURE__ */React10.createElement(UitkLayoutGrid2, {
    space: "three"
  }, /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */React10.createElement(UitkLayoutFlex2, {
    direction: "column",
    justifyContent: "start"
  }, (logo === null || logo === void 0 ? void 0 : logo.standard) && /* @__PURE__ */React10.createElement(UitkLayoutFlexItem2, {
    grow: 0,
    maxWidth: 100
  }, /* @__PURE__ */React10.createElement("div", null, clickableComponent( /* @__PURE__ */React10.createElement(EGDSMark, {
    data: logo.standard
  })))), /* @__PURE__ */React10.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React10.createElement(UitkSpacing2, {
    margin: {
      blockstart: "two"
    }
  }, clickableComponent( /* @__PURE__ */React10.createElement(UitkHeading2, {
    tag: "h2",
    size: 5
  }, heading)))), /* @__PURE__ */React10.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React10.createElement(UitkSpacing2, {
    margin: {
      blockstart: "half"
    }
  }, clickableComponent( /* @__PURE__ */React10.createElement(UitkParagraph2, {
    size: 1
  }, paragraph)))))), /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */React10.createElement(UitkCard, null, link && /* @__PURE__ */React10.createElement(UitkCardLink, null, /* @__PURE__ */React10.createElement(UILinkAction, {
    data: link
  })), /* @__PURE__ */React10.createElement(TransparencyTriggerOrBadge2, {
    badge: badge,
    adTransparencyTrigger: adTransparencyTrigger
  }), /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */React10.createElement(UitkLayoutPosition3, {
    type: "relative",
    position: {
      zindex: "layer2"
    }
  }, /* @__PURE__ */React10.createElement(VideoPlayer, {
    data: video
  })))))), /* @__PURE__ */React10.createElement(UitkSpacingHr, {
    blockMargin: "six"
  }));
};
// src/components/brand-result-listing/brand-result-listing-lazy-fetch.tsx
var BrandResultListingQueryComponent = function (props) {
  var _data_sponsoredContent_brandResultListing_beacons, _data_sponsoredContent_brandResultListing, _data_sponsoredContent;
  var impressionOnly = props.impressionOnly,
    inputs = props.inputs,
    skipSsr = props.skipSsr,
    _props_batchKey = props.batchKey,
    batchKey = _props_batchKey === void 0 ? DEFAULT_SPONSORED_BATCH_KEY : _props_batchKey,
    rooms = props.rooms,
    _props_fetchPolicy = props.fetchPolicy,
    fetchPolicy = _props_fetchPolicy === void 0 ? DEFAULT_SPONSORED_FETCH_POLICY : _props_fetchPolicy;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: fetchPolicy
    }),
    data = _useQuery.data,
    error = _useQuery.error;
  var viewabilityBeacon = data === null || data === void 0 ? void 0 : (_data_sponsoredContent = data.sponsoredContent) === null || _data_sponsoredContent === void 0 ? void 0 : (_data_sponsoredContent_brandResultListing = _data_sponsoredContent.brandResultListing) === null || _data_sponsoredContent_brandResultListing === void 0 ? void 0 : (_data_sponsoredContent_brandResultListing_beacons = _data_sponsoredContent_brandResultListing.beacons) === null || _data_sponsoredContent_brandResultListing_beacons === void 0 ? void 0 : _data_sponsoredContent_brandResultListing_beacons.viewabilityBeacon;
  var componentRef = useMesoViewability({
    viewabilityBeacon: viewabilityBeacon
  }).componentRef;
  if (error || !data || !data.sponsoredContent.brandResultListing) {
    return null;
  }
  var _data_sponsoredContent_brandResultListing1 = data.sponsoredContent.brandResultListing,
    link = _data_sponsoredContent_brandResultListing1.link,
    video = _data_sponsoredContent_brandResultListing1.video,
    impressionAnalytics = _data_sponsoredContent_brandResultListing1.impressionAnalytics;
  fillNumOfTravelersInLink(link, rooms);
  var viewportContent = /* @__PURE__ */React11.createElement(Viewport, null, /* @__PURE__ */React11.createElement(ViewSmall, null, /* @__PURE__ */React11.createElement(IntersectionTracker, {
    linkName: impressionAnalytics.linkName,
    referrerId: impressionAnalytics.referrerId
  }, video ? /* @__PURE__ */React11.createElement(VideoAdContentMobile, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  }) : /* @__PURE__ */React11.createElement(LazyBrandResultListingContentMobile, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  }))), /* @__PURE__ */React11.createElement(ViewMedium, null, /* @__PURE__ */React11.createElement(IntersectionTracker, {
    linkName: impressionAnalytics.linkName,
    referrerId: impressionAnalytics.referrerId
  }, video ? /* @__PURE__ */React11.createElement(VideoAdContent, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  }) : /* @__PURE__ */React11.createElement(LazyBrandResultListingContent, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  }))));
  return /* @__PURE__ */React11.createElement("div", {
    "data-eg-sc": true,
    ref: componentRef
  }, video ? viewportContent : /* @__PURE__ */React11.createElement(UitkCard2, {
    border: true
  }, link && /* @__PURE__ */React11.createElement(UitkCardLink2, null, /* @__PURE__ */React11.createElement(UILinkAction, {
    data: link
  })), viewportContent));
};
BrandResultListingQueryComponent.displayName = "sharedui-BrandResultListingQueryComponent";
var BrandResultListingLazyFetch = withAdBlockDetect(BrandResultListingQueryComponent);
BrandResultListingLazyFetch.displayName = "sharedui-BrandResultListingLazyFetch";
// src/components/brand-result-listing/brand-result-listing-lazy-render.tsx
import React12 from "react";
import LazyLoad from "react-lazy-load";
import { useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard3, UitkCardLink as UitkCardLink3 } from "uitk-react-cards";
var BrandResultListingQueryComponent2 = function (props) {
  var _data_sponsoredContent_brandResultListing_beacons, _data_sponsoredContent_brandResultListing, _data_sponsoredContent;
  var impressionOnly = props.impressionOnly,
    inputs = props.inputs,
    skipSsr = props.skipSsr,
    _props_batchKey = props.batchKey,
    batchKey = _props_batchKey === void 0 ? DEFAULT_SPONSORED_BATCH_KEY : _props_batchKey,
    rooms = props.rooms,
    _props_fetchPolicy = props.fetchPolicy,
    fetchPolicy = _props_fetchPolicy === void 0 ? DEFAULT_SPONSORED_FETCH_POLICY : _props_fetchPolicy;
  var _React12_useState = _sliced_to_array(React12.useState(0), 2),
    lazyOffset = _React12_useState[0],
    setLazyOffset = _React12_useState[1];
  var context = useBexApi2().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery2 = useQuery2(__Query, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: fetchPolicy
    }),
    data = _useQuery2.data,
    error = _useQuery2.error;
  var viewabilityBeacon = data === null || data === void 0 ? void 0 : (_data_sponsoredContent = data.sponsoredContent) === null || _data_sponsoredContent === void 0 ? void 0 : (_data_sponsoredContent_brandResultListing = _data_sponsoredContent.brandResultListing) === null || _data_sponsoredContent_brandResultListing === void 0 ? void 0 : (_data_sponsoredContent_brandResultListing_beacons = _data_sponsoredContent_brandResultListing.beacons) === null || _data_sponsoredContent_brandResultListing_beacons === void 0 ? void 0 : _data_sponsoredContent_brandResultListing_beacons.viewabilityBeacon;
  var componentRef = useMesoViewability({
    viewabilityBeacon: viewabilityBeacon
  }).componentRef;
  React12.useEffect(function () {
    setLazyOffset(window.innerHeight);
  }, []);
  if (error || !data || !data.sponsoredContent.brandResultListing) {
    return null;
  }
  var _data_sponsoredContent_brandResultListing1 = data.sponsoredContent.brandResultListing,
    link = _data_sponsoredContent_brandResultListing1.link,
    video = _data_sponsoredContent_brandResultListing1.video,
    impressionAnalytics = _data_sponsoredContent_brandResultListing1.impressionAnalytics;
  fillNumOfTravelersInLink(link, rooms);
  var viewportContent = /* @__PURE__ */React12.createElement(Viewport2, null, /* @__PURE__ */React12.createElement(ViewSmall2, null, /* @__PURE__ */React12.createElement(LazyLoad, {
    offset: lazyOffset
  }, /* @__PURE__ */React12.createElement(IntersectionTracker2, {
    linkName: impressionAnalytics.linkName,
    referrerId: impressionAnalytics.referrerId
  }, video ? /* @__PURE__ */React12.createElement(VideoAdContentMobile, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  }) : /* @__PURE__ */React12.createElement(LazyBrandResultListingContentMobile, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  })))), /* @__PURE__ */React12.createElement(ViewMedium2, null, /* @__PURE__ */React12.createElement(LazyLoad, {
    offset: lazyOffset / 2
  }, /* @__PURE__ */React12.createElement(IntersectionTracker2, {
    linkName: impressionAnalytics.linkName,
    referrerId: impressionAnalytics.referrerId
  }, video ? /* @__PURE__ */React12.createElement(VideoAdContent, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  }) : /* @__PURE__ */React12.createElement(LazyBrandResultListingContent, {
    data: data.sponsoredContent.brandResultListing,
    impressionOnly: impressionOnly
  })))));
  return /* @__PURE__ */React12.createElement("div", {
    "data-eg-sc": true,
    ref: componentRef
  }, video ? viewportContent : /* @__PURE__ */React12.createElement(UitkCard3, {
    border: true
  }, link && /* @__PURE__ */React12.createElement(UitkCardLink3, null, /* @__PURE__ */React12.createElement(UILinkAction, {
    data: link
  })), viewportContent));
};
BrandResultListingQueryComponent2.displayName = "sharedui-BrandResultListingQueryComponent";
var BrandResultListingLazyRender = withAdBlockDetect(BrandResultListingQueryComponent2);
BrandResultListingLazyRender.displayName = "sharedui-BrandResultListingLazyRender";
// src/components/brand-result-listing/brand-result-listing.tsx
var __Query = gql8(_templateObject8(), EGDSImage.fragment, EGDSStandardBadge.fragment, EGDSMark.fragment, VideoPlayer.fragment, UILinkAction.fragment, clientSideAnalyticsFragment, SponsoredContentBeaconsFragment);
var BrandResultListing = function (props) {
  var _window, _window1;
  var _React13_useState = _sliced_to_array(React13.useState(0), 2),
    lazyOffset = _React13_useState[0],
    setLazyOffset = _React13_useState[1];
  React13.useEffect(function () {
    var _window;
    setLazyOffset((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight);
  }, []);
  return /* @__PURE__ */React13.createElement(Experiment2, {
    name: "MeSo_Remove_Eager_Fetch_on_ads_Web"
  }, /* @__PURE__ */React13.createElement(ExperimentControl2, null, /* @__PURE__ */React13.createElement(BrandResultListingLazyRender, _object_spread({}, props))), /* @__PURE__ */React13.createElement(ExperimentVariant2, {
    bucket: 1
  }, (lazyOffset || typeof window !== "undefined" && ((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight)) && /* @__PURE__ */React13.createElement(Viewport3, null, /* @__PURE__ */React13.createElement(ViewSmall3, null, /* @__PURE__ */React13.createElement(LazyLoad2, {
    offset: typeof window !== "undefined" ? (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.innerHeight : 0
  }, /* @__PURE__ */React13.createElement(BrandResultListingLazyFetch, _object_spread({}, props)))), /* @__PURE__ */React13.createElement(ViewMedium3, null, /* @__PURE__ */React13.createElement(LazyLoad2, {
    offset: typeof window !== "undefined" && window ? window.innerHeight / 2 : 0
  }, /* @__PURE__ */React13.createElement(BrandResultListingLazyFetch, _object_spread({}, props)))))));
};
BrandResultListing.displayName = "sharedui-BrandResultListing";
export { BrandResultListing, __Query }; /* istanbul ignore file -- @preserve */